import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import CheckIcon from "@mui/icons-material/Check";
import "./HomeBannerSwiper.css";

import { Autoplay, Pagination } from "swiper/modules";
import CloseIcon from "@mui/icons-material/Close";

// Carousel assets
import petCt from "../../assets/final-images/homepage/Carousel/pet_Ct.mp4";
import petCt_m from "../../assets/final-images/homepage/Carousel/pet_Ct mobile size.mp4";
import mri from "../../assets/final-images/homepage/Carousel/mri_large.mp4";
import mri_m from "../../assets/final-images/homepage/Carousel/mri_small.mp4";
import cardiac from "../../assets/final-images/homepage/Carousel/cardiac.jpg";
import cardiac_m from "../../assets/final-images/homepage/Carousel/cta.jpg";
import lung from "../../assets/final-images/homepage/Carousel/lung_.jpg";
import womenimaging from "../../assets/final-images/homepage/Carousel/mammograpgy-01.jpg";
import womenimaging_m from "../../assets/final-images/homepage/Carousel/mammograpgy-01 (1).jpg";
import vascular from "../../assets/final-images/homepage/Carousel/vascular.jpg";
import vascular_m from "../../assets/final-images/homepage/Carousel/vascularmobile.jpg";
import personalinjury from "../../assets/final-images/homepage/Carousel/personal.jpg";
import personalinjury_m from "../../assets/final-images/homepage/Carousel/personal-m.jpg";
import dti from "../../assets/final-images/homepage/Carousel/dti.jpg";
import dti_m from "../../assets/final-images/homepage/Carousel/dtimobile.jpg";

import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import { Link } from "react-router-dom";
import { useRef, useState, useEffect } from "react";

export default function HomeBannerSwiper() {
  const swiperRef = useRef(null);
  const [open, setOpen] = useState(false);
  const [activeService, setActiveService] = useState(null);

  const handleOpen = (key) => {
    setActiveService(servicesData[key]);
    setOpen(true);
    swiperRef.current?.autoplay?.stop();
    if (swiperRef.current) swiperRef.current.allowTouchMove = false;
  };

  const handleClose = () => {
    setOpen(false);
    swiperRef.current?.autoplay?.start();
    if (swiperRef.current) swiperRef.current.allowTouchMove = true;
  };

  useEffect(() => {
    if (!open && swiperRef.current) {
      setTimeout(() => {
        swiperRef.current?.autoplay?.start();
        swiperRef.current?.update();
      }, 300);
    }
  }, [open]);

  const servicesData = {
    petCt: {
      id: 1,
      title: "PET-CT for Cancer & Neurology",
      tagline: "Precision where it matters most.",
      focusline: "",
      focuslinetwo: "Used for:",
      items: [
        "Oncology PET-CT",
        "PSMA PET-CT for prostate cancer",
        "Brain PET-CT for Alzheimer’s disease",
      ],
      features: [
        "Early detection",
        "Accurate staging",
        "Treatment response monitoring",
      ],

      notes:
        "Backed by national standards and evidence-based imaging protocols.",
    },

    mri: {
      id: 2,
      title: "MRI",
      tagline: "Powerful. Quiet. Open. Intelligent.",
      items: ["Wide-Bore High-Field 1.5 T MRI", "Open & Bariatric MRI"],
      features: [
        "Claustrophobic patient friendly",
        "Bariatric support",
        "Faster exams",
        "AI-enhanced image quality comparable to traditional high-field systems",
      ],
      focusline: "",
      focuslinetwo: "Designed for:",

      notes: "The result: comfort without compromise.",
    },

    cardiacImaging: {
      id: 3,
      title: "Cardiac Imaging",
      tagline: "See heart disease-before symptoms appear.",
      items: [
        "Coronary CT Angiography (CTA)",
        "AI-assisted plaque analysis/FFR",
        "Non-invasive heart imaging",
      ],
      features: [
        "Evaluate coronary artery disease",
        "Guide preventive care",
        "Reduce unnecessary invasive procedures",
      ],
      focusline: "",
      focuslinetwo: "Used to:",
    },

    lungCancerScreening: {
      id: 4,
      title: "Lung Cancer Screening",
      tagline: "Early detection saves lives.",
      items: [
        "Low-dose CT",
        "160-slice CT technology",
        "Optimized for minimal radiation exposure",
      ],

      focusline: "",
      notes: "Recommended for eligible patients based on national guidelines.",
    },

    womensImaging: {
      id: 5,
      title: "Women’s Imaging",
      tagline: "Confidence through clarity.",
      items: [
        "3D Mammography (Tomosynthesis)",
        "Breast Ultrasound",
        "Breast MRI",
      ],
      focusline: "",
      notes: "Focused on early detection, accuracy, and compassionate care.",
    },

    vascularUltrasound: {
      id: 6,
      title: "Vascular & Preventive Ultrasound",
      tagline: "Information that empowers.",
      items: [
        "Carotid artery screening",
        "Abdominal aortic aneurysm screening",
        "Venous and arterial Doppler studies",
      ],
      focusline: "",
      notes: "Non-invasive. No radiation. Actionable insights.",
    },

    personalInjuryImaging: {
      id: 7,
      title: "Personal Injury Imaging",
      tagline: "Clarity after trauma. Evidence you can trust.",
      items: [
        "Motor vehicle accident imaging",
        "Personal injury and PIP cases",
        "Neurologic and spinal trauma",
      ],
      focusline:
        "Citrus Diagnostic Center is a regional leader in imaging for:",

      notes: "Trusted imaging for injury-related cases.",
    },

    tbiImaging: {
      id: 8,
      title: "Traumatic Brain Injury (TBI)",
      tagline:
        "Advanced neuroimaging protocols designed to detect injuries that conventional imaging may miss",
      items: [
        "High-resolution Brain MRI",
        "Diffusion Tensor Imaging (DTI) for white matter injury",
        "Evidence-based neurotrauma protocols",
      ],
      features: [
        "Concussion",
        "Post-concussive symptoms",
        "Cognitive and neurologic deficits",
      ],
      focusline: "",
      focuslinetwo: "Used to evaluate:",
      notes: "Evidence-based neurotrauma imaging protocols.",
    },
  };
  return (
    <>
      <Dialog
        open={open}
        onClose={handleClose}
        maxWidth={false}
        PaperProps={{
          className:
            "3xl:w-[50vw] 3xl:h-[65vh] xl:w-[60vw] xl:h-[80vh] max-w-none bg-black/60",
        }}
      >
        <DialogContent className="bg-black border relative rounded-2xl border-[#ffffff3d] flex justify-center items-center text-white overflow-auto p-3 2xl:p-10">
          <div className="w-full md:w-[90%] pt-4 font-robout">
            {activeService && (
              <>
                <h2 className="lg:text-[32px] text-[20px] leading-[1.4em] text-[#f5f5f5] font-normal text-center mb-2 ">
                  {activeService.title}
                </h2>
                <h3 className="text-[#cccccc]  text-[16px] leading-[1.4em] font-medium text-base text-center  md:mb-8 md:px-6 px-2">
                  {activeService.tagline}
                </h3>

                {/* GRID START */}
                <div className="grid md:grid-cols-2 grid-cols-1 align-middle content-center gap-5 lg:gap-10 my-1  md:my-8">
                  {/* LEFT COLUMN */}
                  <div className="flex flex-col items-start ">
                    <h3 className="min-h-[20px] text-lg font-bold mb-4">
                      {activeService.focusline}
                    </h3>

                    {activeService.items && (
                      <ul className="space-y-2">
                        {activeService.items.map((item, i) => (
                          <li
                            key={i}
                            className="flex flex-row gap-2 items-center text-[#cccccc]  text-[16px] leading-[1.4em] font-medium"
                          >
                            <CheckIcon
                              fontSize="10px"
                              className="text-base text-[#bf9c5e]"
                            />{" "}
                            {item}
                          </li>
                        ))}
                      </ul>
                    )}
                  </div>

                  {/* RIGHT COLUMN */}
                  <div className="flex flex-col items-start ">
                    <h3 className="min-h-[20px] text-[#f5f5f5]  text-[16px] leading-[1.4em] font-normal mb-4">
                      {activeService.focuslinetwo}
                    </h3>

                    {activeService.features && (
                      <ul className=" space-y-2">
                        {activeService.features.map((item, i) => (
                          <li
                            key={i}
                            className="flex flex-row gap-2 items-center text-[#cccccc]  text-[16px] leading-[1.4em] font-medium"
                          >
                            <CheckIcon
                              fontSize="10px"
                              className="text-base text-[#bf9c5e]"
                            />{" "}
                            {item}
                          </li>
                        ))}
                      </ul>
                    )}
                  </div>
                </div>
                {/* GRID END */}

                <p className="mt-6 opacity-95 min-h-4 text-[#cccccc]  text-[16px] leading-[1.4em] font-medium text-center">
                  {activeService.notes}
                </p>

                <div className="flex justify-center my-6">
                  <Link
                    to="/diagnostic-imaging-services"
                    className="px-8 py-2 rounded-3xl bg-white text-[14px] lg:text-[16px] leading-[1.4em] text-black font-normal hover:bg-black hover:border hover:text-white border border-[#ffffff5d] transition-all duration-200"
                  >
                    View All Services
                  </Link>
                </div>
              </>
            )}
          </div>

          {/* CLOSE BUTTON */}
          <div className="absolute md:top-4 md:right-4 top-1 right-1">
            <button
              onClick={handleClose}
              className="flex justify-center items-center w-10 h-10 bg-[#6b6b6b] text-white rounded-full opacity-85 hover:opacity-100 transition"
            >
              <CloseIcon />
            </button>
          </div>
        </DialogContent>
      </Dialog>

      <div className="flex justify-center flex-col gap-10 items-center relative top-0 font-robout xl:top-24 mb-10 xl:mb-44 xl:px-0 px-5">
        <Swiper
          onSwiper={(swiper) => (swiperRef.current = swiper)}
          breakpoints={{
            0: { slidesPerView: 1 },
            1024: { slidesPerView: 1.2 },
            1536: { slidesPerView: 1.2 },
            1600: { slidesPerView: 1.5 },
          }}
          spaceBetween={15}
          centeredSlides={true}
          loop={true}
          pagination={{
            el: ".custom-swiper-pagination",
            clickable: true,
          }}
          autoplay={{
            delay: 4500,
            disableOnInteraction: false,
          }}
          modules={[Autoplay, Pagination]}
          className="mySwiper custom-swiper w-full 
                     h-[420px] 
                     md:h-[560px] 
                     lg:h-[620px] 
                     xl:h-[660px]"
        >
          {[
            {
              key: "petCt",
              title: "PET-CT for Cancer & Neurology",
              tagline: "Precision where it matters most.",
              asset: petCt,
              assetMobile: petCt_m,
              isVideo: true,
            },
            {
              key: "mri",
              title: "MRI (Magnetic Resonance Imaging)",
              tagline: "Powerful. Quiet. Open. Intelligent.",
              asset: mri,
              assetMobile: mri_m,
              isVideo: true,
            },
            {
              key: "cardiacImaging",
              title: "Cardiac Imaging",
              tagline: "See heart disease-before symptoms appear.",
              asset: cardiac,
              assetMobile: cardiac_m,
            },
            {
              key: "lungCancerScreening",
              title: "Lung Cancer Screening",
              tagline: "Early detection saves lives.",
              asset: lung,
              assetMobile: lung,
            },
            {
              key: "womensImaging",
              title: "Women’s Imaging",
              tagline: "Confidence through clarity.",
              asset: womenimaging,
              assetMobile: womenimaging_m,
            },
            {
              key: "vascularUltrasound",
              title: "Vascular & Preventive Ultrasound",
              tagline: "Information that empowers.",
              asset: vascular,
              assetMobile: vascular_m,
            },
            {
              key: "personalInjuryImaging",
              title: "Personal Injury Imaging",
              tagline: "Clarity after trauma. Evidence you can trust.",
              asset: personalinjury,
              assetMobile: personalinjury_m,
            },
            {
              key: "tbiImaging",
              title: "Traumatic Brain Injury (TBI)",
              tagline:
                "Advanced neuroimaging protocols designed to detect injuries that conventional imaging may miss.",
              asset: dti,
              assetMobile: dti_m,
            },
          ].map((slide) => (
            <SwiperSlide key={slide.key}>
              {({ isActive }) => (
                <div
                  className={`relative w-full h-full overflow-hidden bg-black ${isActive ? "border-[1px] border-[#4d4d4d]" : ""}`}
                >
                  {slide.isVideo ? (
                    <>
                      <video
                        className="w-full h-full object-contain"
                        autoPlay
                        loop
                        muted
                        playsInline
                      >
                        <source src={slide.asset} type="video/mp4" />
                      </video>
                      <video
                        className="w-full h-full object-contain xl:hidden block"
                        autoPlay
                        loop
                        muted
                        playsInline
                      >
                        <source src={slide.assetMobile} type="video/mp4" />
                      </video>
                    </>
                  ) : (
                    <>
                      <img
                        src={slide.asset}
                        alt={slide.title}
                        className="w-full h-full object-contain xl:block hidden"
                      />
                      <img
                        src={slide.assetMobile}
                        alt={slide.title}
                        className="w-full h-full object-contain xl:hidden block"
                      />
                    </>
                  )}

                  {/* Text Overlay */}
                  <div className="absolute bottom-0 left-0 w-full text-left px-6 lg:px-20 py-6 lg:pt-10 bg-gradient-to-t from-black/90 via-black/50 to-transparent">
                    <h2 className="lg:text-[32px] text-[20px] leading-[1.4em] text-[#f5f5f5] font-normal py-1">
                      {slide.title}
                    </h2>
                    <h3 className="text-[#cccccc] text-[16px] leading-[1.4em] font-medium">
                      {slide.tagline}
                    </h3>
                    <button
                      onClick={() => handleOpen(slide.key)}
                      className="px-8 py-2 rounded-3xl my-4 bg-white font-normal text-[16px] leading-[1.4em] text-black hover:bg-black hover:border border border-[#ffffff5d] hover:text-white transition-all"
                    >
                      View
                    </button>
                  </div>
                </div>
              )}
            </SwiperSlide>
          ))}
        </Swiper>

        {/* Pagination Dots */}
        <div className="custom-swiper-pagination w-full flex justify-center items-center mt-4" />

        {/* Bottom Text */}
        <div className="xl:w-3/5 flex flex-col justify-center items-center text-center py-10">
          <p className="w-full xl:w-[60%] mx-auto px-4 md:px-0">
            Comprehensive imaging services also include CT, nuclear medicine,
            ultrasound, digital X-ray, echocardiography, and bone density
            scanning.
          </p>
          <div className="flex justify-center items-center p-2 mt-10">
            <Link
              to="/diagnostic-imaging-services"
              className="px-8 py-2.5 rounded-3xl bg-white font-normal text-black text-[16px] leading-[1.4em] hover:bg-black hover:border hover:text-white border border-[#ffffff5d] transition-all duration-200"
            >
              View All Services
            </Link>
          </div>
        </div>
      </div>
    </>
  );
}
